import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
    download = (data: object, filename: string) => {
        // Convert to JSON
        const jsonContent = JSON.stringify(data, null, 2);

        // Trigger download
        const blob = new Blob([jsonContent], { type: 'application/json' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        globalThis.URL.revokeObjectURL(url);
    };
}
